export function sortFieldsAlphabetically(fields, labelMetadata) {
	fields.sort((a, b) => {
		if (labelMetadata[a]?.label && labelMetadata[b]?.label) {
			return labelMetadata[a]?.label?.localeCompare(labelMetadata[b]?.label);
		} else if (!labelMetadata[a]?.label && labelMetadata[b]?.label) {
			return labelMetadata[a]?.key?.localeCompare(labelMetadata[b]?.label);
		} else if (labelMetadata[a]?.label && !labelMetadata[b]?.label) {
			return labelMetadata[a]?.label?.localeCompare(labelMetadata[b]?.key);
		}
		return labelMetadata[a]?.key?.localeCompare(labelMetadata[b]?.key);
	});
}
